import configuration from "../configuration/keys";
import i18n from "../constants/i18n";
import getCoreUIStore from "../stores/core/core-ui-store";
import ET3Div from "../core/et3-div";
import { withLiteObserverAndTheme } from "../core/et3-enhanced-render";
import Et3Text from "../core/et3-text";

const Footer = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const sideBarVisible = getCoreUIStore().shouldShowSideBar.get();
  const mainWidth = sideBarVisible ? 1600 : 1900;

  return (
    <footer
      style={{
        backgroundColor: colors.all.transparent
      }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={mainWidth}
        height={55}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={20}
          text={`${i18n.get("COPYRIGHT")} ${i18n.get(
            "ET3ARRAF_SAL"
          )}  ${i18n.get("ALL_RIGHTS_RESERVED")} ${i18n.get(
            "VERSION"
          )} ${configuration.version}`}
          isSpan={false}
          color={colors.all.maastrichtBlue}
          style={{}}
        />
      </ET3Div>
    </footer>
  );
});
export default Footer;
